export default __webpack_public_path__ + "static/media/SharpSans-bold.aa00a9dd.otf";